import React, { useState } from 'react';
 
const ReadMore = ({ text, maxLength }) => {
  const [isTruncated, setIsTruncated] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
 
  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };
 
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
 
  return (
    <div>
      {isTruncated ? (
        <div style={{fontSize: "1rem",  fontWeight: "400",}}>
          {text?.slice(0, maxLength)}
          <span onClick={toggleTruncate} style={{color:"blue", cursor: 'pointer'}}>... Read more</span>
        </div>
      ) : (
        <div style={{width:"90%", fontSize: "1rem",  fontWeight: "400",}}>
          {text}
          <span onClick={toggleTruncate} style={{color:"blue", cursor: 'pointer'}} > Read less</span>
        </div>
      )}
      {showPopup && (
        <div className="popup">
          This is a popup!
          <button onClick={togglePopup}>Close</button>
        </div>
      )}
    </div>
  );
};
 
export default ReadMore;